<template>
  <md-card>
    <md-card-content>
      <div class="md-layout">
        <div class="md-layout-item md-size-100" style="padding-bottom: 20px">
          <md-toolbar class="md-success" md-elevation="1">
            <div class="md-toolbar-row">
              <div class="md-toolbar-section-start">
                <h3
                  class="md-title"
                  style="padding-left: 20px; padding-bottom: 10px"
                >
                  仿真项目
                </h3>
              </div>
              <div class="md-toolbar-section-end">
                <drop-down direction="down">
                  <md-button
                    slot="title"
                    class="md-button md-success dropdown-toggle"
                    data-toggle="dropdown"
                  >
                    专业分类
                  </md-button>
                  <ul class="dropdown-menu dropdown-menu-right">
                    <li
                      v-for="item in majorListData"
                      :key="item.index"
                      @click="categorySelected('profession', item.index)"
                    >
                      <a href="#">{{ item.name }}</a>
                    </li>
                  </ul>
                </drop-down>
                <drop-down direction="down">
                  <md-button
                    slot="title"
                    class="md-button md-success dropdown-toggle"
                    data-toggle="dropdown"
                  >
                    行业分类
                  </md-button>
                  <ul class="dropdown-menu dropdown-menu-right">
                    <li
                      v-for="item in industryListData"
                      :key="item.index"
                      @click="categorySelected('industry', item.index)"
                    >
                      <a href="#">{{ item.name }}</a>
                    </li>
                  </ul>
                </drop-down>
                <md-button class="md-success" @click="clearFilter">
                  清除筛选 <md-icon>filter_list_off</md-icon>
                </md-button>
              </div>
            </div>
          </md-toolbar>
        </div>

        <div class="md-layout-item md-size-100">
          <md-field>
            <md-input
              type="search"
              class="mb-3"
              clearable
              style="width: 200px"
              placeholder="按名称查找..."
              v-model="searchQuery"
              @keyup.enter="handleSearch"
            >
            </md-input>
          </md-field>
          <md-tooltip md-delay="300" md-direction="top">
            按回车以检索
          </md-tooltip>
        </div>
        <div
          class="
            md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-25
          "
        >
          <product-card header-animation="false">
            <img class="img" slot="imageHeader" :src="product1" />
            <md-icon slot="fixed-button">build</md-icon>
            <template slot="first-button">
              <md-icon>art_track</md-icon>
              <md-tooltip md-direction="bottom">View</md-tooltip>
            </template>
            <h4 slot="title" class="title">
              <a href="#pablo" @click="openProject()"> 供配电技术</a>
            </h4>
            <div slot="description" class="card-description">
              模拟现场真实环境,500KV直流换流站、220KV/110KV变电站、35KV/10KV控制室,运行、维护、检修等任务实训
            </div>
            <template slot="footer">
              <div class="price">
                <h6>899 人使用</h6>
              </div>
              <div class="stats">
                <p class="category">
                  <md-icon>star_border_purple500</md-icon>
                  张小波 团队
                </p>
              </div>
            </template>
          </product-card>
        </div>
        <div
          class="
            md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-25
          "
        >
          <product-card header-animation="false">
            <img class="img" slot="imageHeader" :src="product2" />
            <md-icon slot="fixed-button">build</md-icon>
            <template slot="first-button">
              <md-icon>art_track</md-icon>
              <md-tooltip md-direction="bottom">View</md-tooltip>
            </template>
            <h4 slot="title" class="title">
              <a href="#pablo" @click="openProject()">电气控制与PLC应用技术</a>
            </h4>
            <div slot="description" class="card-description">
              涵盖抢答器控制系统、十字路口交通灯控制系统、可逆运行能耗制动等25项实训任务,与实体设备可孪生联动
            </div>
            <template slot="footer">
              <div class="price">
                <h6>1119 人使用</h6>
              </div>
              <div class="stats">
                <p class="category">
                  <md-icon>star_border_purple500</md-icon>
                  林力 团队
                </p>
              </div>
            </template>
          </product-card>
        </div>
        <div
          class="
            md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-25
          "
        >
          <product-card header-animation="false">
            <img class="img" slot="imageHeader" :src="product3" />
            <md-icon slot="fixed-button">build</md-icon>
            <template slot="first-button">
              <md-icon>art_track</md-icon>
              <md-tooltip md-direction="bottom">View</md-tooltip>
            </template>
            <h4 slot="title" class="title">
              <a href="#pablo" @click="openProject()">建筑设备监控系统</a>
            </h4>
            <div slot="description" class="card-description">
              集虚实结合、虚拟仿真训练一体，可实现控制系统电气安装检测、给排水系统安装调试等实训项目线上线下同步训练
            </div>
            <template slot="footer">
              <div class="price">
                <h6>1459 人使用</h6>
              </div>
              <div class="stats">
                <p class="category">
                  <md-icon>star_border_purple500</md-icon>
                  王朔 团队
                </p>
              </div>
            </template>
          </product-card>
        </div>
        <div
          class="
            md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-25
          "
        >
          <product-card header-animation="false">
            <img class="img" slot="imageHeader" :src="product1" />
            <md-icon slot="fixed-button">build</md-icon>
            <template slot="first-button">
              <md-icon>art_track</md-icon>
              <md-tooltip md-direction="bottom">View</md-tooltip>
            </template>
            <h4 slot="title" class="title">
              <a href="#pablo" @click="openProject()"> 供配电技术</a>
            </h4>
            <div slot="description" class="card-description">
              模拟现场真实环境,500KV直流换流站、220KV/110KV变电站、35KV/10KV控制室,运行、维护、检修等任务实训
            </div>
            <template slot="footer">
              <div class="price">
                <h6>899 人使用</h6>
              </div>
              <div class="stats">
                <p class="category">
                  <md-icon>star_border_purple500</md-icon>
                  张小波 团队
                </p>
              </div>
            </template>
          </product-card>
        </div>
        <div
          class="
            md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-25
          "
        >
          <product-card header-animation="false">
            <img class="img" slot="imageHeader" :src="product2" />
            <md-icon slot="fixed-button">build</md-icon>
            <template slot="first-button">
              <md-icon>art_track</md-icon>
              <md-tooltip md-direction="bottom">View</md-tooltip>
            </template>
            <h4 slot="title" class="title">
              <a href="#pablo" @click="openProject()">电气控制与PLC应用技术</a>
            </h4>
            <div slot="description" class="card-description">
              涵盖抢答器控制系统、十字路口交通灯控制系统、可逆运行能耗制动等25项实训任务,与实体设备可孪生联动
            </div>
            <template slot="footer">
              <div class="price">
                <h6>1119 人使用</h6>
              </div>
              <div class="stats">
                <p class="category">
                  <md-icon>star_border_purple500</md-icon>
                  林力 团队
                </p>
              </div>
            </template>
          </product-card>
        </div>
        <div
          class="
            md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-25
          "
        >
          <product-card header-animation="false">
            <img class="img" slot="imageHeader" :src="product3" />
            <md-icon slot="fixed-button">build</md-icon>
            <template slot="first-button">
              <md-icon>art_track</md-icon>
              <md-tooltip md-direction="bottom">View</md-tooltip>
            </template>
            <h4 slot="title" class="title">
              <a href="#pablo" @click="openProject()">建筑设备监控系统</a>
            </h4>
            <div slot="description" class="card-description">
              集虚实结合、虚拟仿真训练一体，可实现控制系统电气安装检测、给排水系统安装调试等实训项目线上线下同步训练
            </div>
            <template slot="footer">
              <div class="price">
                <h6>1459 人使用</h6>
              </div>
              <div class="stats">
                <p class="category">
                  <md-icon>star_border_purple500</md-icon>
                  王朔 团队
                </p>
              </div>
            </template>
          </product-card>
        </div>
        <div
          class="
            md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-25
          "
        >
          <product-card header-animation="false">
            <img class="img" slot="imageHeader" :src="product1" />
            <md-icon slot="fixed-button">build</md-icon>
            <template slot="first-button">
              <md-icon>art_track</md-icon>
              <md-tooltip md-direction="bottom">View</md-tooltip>
            </template>
            <h4 slot="title" class="title">
              <a href="#pablo" @click="openProject()"> 供配电技术</a>
            </h4>
            <div slot="description" class="card-description">
              模拟现场真实环境,500KV直流换流站、220KV/110KV变电站、35KV/10KV控制室,运行、维护、检修等任务实训
            </div>
            <template slot="footer">
              <div class="price">
                <h6>899 人使用</h6>
              </div>
              <div class="stats">
                <p class="category">
                  <md-icon>star_border_purple500</md-icon>
                  张小波 团队
                </p>
              </div>
            </template>
          </product-card>
        </div>
        <div
          class="
            md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-25
          "
        >
          <product-card header-animation="false">
            <img class="img" slot="imageHeader" :src="product2" />
            <md-icon slot="fixed-button">build</md-icon>
            <template slot="first-button">
              <md-icon>art_track</md-icon>
              <md-tooltip md-direction="bottom">View</md-tooltip>
            </template>
            <h4 slot="title" class="title">
              <a href="#pablo" @click="openProject()">电气控制与PLC应用技术</a>
            </h4>
            <div slot="description" class="card-description">
              涵盖抢答器控制系统、十字路口控制系统、立体入库单元、可逆运行能耗制动等25项实训任务,与实体设备可孪生联动
            </div>
            <template slot="footer">
              <div class="price">
                <h6>1119 人使用</h6>
              </div>
              <div class="stats">
                <p class="category">
                  <md-icon>star_border_purple500</md-icon>
                  林力 团队
                </p>
              </div>
            </template>
          </product-card>
        </div>
        <div
          class="
            md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-25
          "
        >
          <product-card header-animation="false">
            <img class="img" slot="imageHeader" :src="product3" />
            <md-icon slot="fixed-button">build</md-icon>
            <template slot="first-button">
              <md-icon>art_track</md-icon>
              <md-tooltip md-direction="bottom">View</md-tooltip>
            </template>
            <h4 slot="title" class="title">
              <a href="#pablo" @click="openProject()">建筑设备监控系统</a>
            </h4>
            <div slot="description" class="card-description">
              集虚实结合、虚拟仿真训练一体，可实现控制系统电气安装检测、给排水系统安装调试等实训项目线上线下同步训练
            </div>
            <template slot="footer">
              <div class="price">
                <h6>1459 人使用</h6>
              </div>
              <div class="stats">
                <p class="category">
                  <md-icon>star_border_purple500</md-icon>
                  王朔 团队
                </p>
              </div>
            </template>
          </product-card>
        </div>
        <div
          class="
            md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-25
          "
        >
          <product-card header-animation="false">
            <img class="img" slot="imageHeader" :src="product1" />
            <md-icon slot="fixed-button">build</md-icon>
            <template slot="first-button">
              <md-icon>art_track</md-icon>
              <md-tooltip md-direction="bottom">View</md-tooltip>
            </template>
            <h4 slot="title" class="title">
              <a href="#pablo" @click="openProject()"> 供配电技术</a>
            </h4>
            <div slot="description" class="card-description">
              模拟现场真实环境,500KV直流换流站、220KV/110KV变电站、35KV/10KV控制室,运行、维护、检修等任务实训
            </div>
            <template slot="footer">
              <div class="price">
                <h6>899 人使用</h6>
              </div>
              <div class="stats">
                <p class="category">
                  <md-icon>star_border_purple500</md-icon>
                  张小波 团队
                </p>
              </div>
            </template>
          </product-card>
        </div>
        <div
          class="
            md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-25
          "
        >
          <product-card header-animation="false">
            <img class="img" slot="imageHeader" :src="product2" />
            <md-icon slot="fixed-button">build</md-icon>
            <template slot="first-button">
              <md-icon>art_track</md-icon>
              <md-tooltip md-direction="bottom">View</md-tooltip>
            </template>
            <h4 slot="title" class="title">
              <a href="#pablo" @click="openProject()">电气控制与PLC应用技术</a>
            </h4>
            <div slot="description" class="card-description">
              涵盖抢答器控制系统、横臂搬运单元、立体入库单元、可逆运行能耗制动等25项实训任务,与实体设备可孪生联动
            </div>
            <template slot="footer">
              <div class="price">
                <h6>1119 人使用</h6>
              </div>
              <div class="stats">
                <p class="category">
                  <md-icon>star_border_purple500</md-icon>
                  林力 团队
                </p>
              </div>
            </template>
          </product-card>
        </div>
        <div
          class="
            md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-25
          "
        >
          <product-card header-animation="false">
            <img class="img" slot="imageHeader" :src="product3" />
            <md-icon slot="fixed-button">build</md-icon>
            <template slot="first-button">
              <md-icon>art_track</md-icon>
              <md-tooltip md-direction="bottom">View</md-tooltip>
            </template>
            <h4 slot="title" class="title">
              <a href="#pablo" @click="openProject()">建筑设备监控系统</a>
            </h4>
            <div slot="description" class="card-description">
              集虚实结合、虚拟仿真训练一体，可实现控空调水系统安装调试、给排水系统安装调试等实训项目线上线下同步训练
            </div>
            <template slot="footer">
              <div class="price">
                <h6>1459 人使用</h6>
              </div>
              <div class="stats">
                <p class="category">
                  <md-icon>star_border_purple500</md-icon>
                  王朔 团队
                </p>
              </div>
            </template>
          </product-card>
        </div>
        <div class="md-layout-item md-size-100">
          <pagination
            class="pagination-no-border pagination-success"
            v-model="currentPage"
            style="justify-content: center"
            :total="totalItems"
            :perPage="perPage"
          >
          </pagination>
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>
<script>
import { ProductCard, Pagination } from "@/components";
export default {
  components: {
    ProductCard,
    Pagination,
  },
  methods: {
    openProject: function () {
      window.open("./simprojectdetail", "_blank");
    },
  },
  data() {
    return {
      product1: "./img/bdz.png",
      product2: "./img/plc.png",
      product3: "./img/jzjk.png",
      seq2: 0,
    };
  },
};
</script>
<style lang="css" scoped>
.img-card {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.img {
  width: 200px;
  height: 180px;
  margin: 0 !important;
}

.md-group {
  margin-bottom: 24px;
}

.md-button {
  border-radius: 0;
}

.md-tab {
  max-width: 600px;
  max-height: 400px;
  overflow: auto;
}
</style>